<template>
    <v-app id="app">

        <v-card flat tile id="promo-area">
            <v-overlay
                    absolute="absolute"
                    opacity="1"
                    color="white"
                    :value="bundleActiveToggle">

                <v-card light flat style="width: 100vw; height: 70vh">

                    <div style="width: 100%; height: 100%;">




                        <div style="width: 100%; height: 30%; display: flex; justify-content: center; align-items: center">
                            <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
                                <div style="height: 60%; width: 40%" class="bundle-number-2" v-bind:style="{color: bundleTextColor, background: bundleBackgroundColor, backgroundSize: coverBackground}">{{bundleName}}</div>
                            </div>
                        </div>

                        <div style="font-size: 2vh ;width: 100%; height: 10%; display: flex; justify-content: center; align-items: center">
                            Active For
                        </div>

                        <div style="padding-left: 15% ;padding-right: 15% ;width: 100%; height: 40%; display: flex; justify-content: center; align-items: center">

                            <v-slide-x-transition>
                            <div v-if="showDays" style="width: 25%; height: 100%; float: left">
                                <div style="width: 100%; height: 60%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 15vh">
                                    {{activeDays}}
                                </div>
                                <div style="width: 100%; height: 40%; display: flex; justify-content: center; align-items: center">
                                    Days
                                </div>
                            </div>
                            </v-slide-x-transition>



                            <div style="width: 25%; height: 100%; float: left">
                                <div style="width: 100%; height: 60%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 15vh">
                                    {{activeHours}}
                                </div>
                                <div style="width: 100%; height: 40%; display: flex; justify-content: center; align-items: center">
                                    Hours
                                </div>
                            </div>

                            <div style="width: 2%; height: 100%; float: left">
                                <div style="width: 100%; height: 60%; display: flex; justify-content: center; align-items: center; font-size: 10vh">
                                    :
                                </div>
                                <div style="width: 100%; height: 40%; display: flex; justify-content: center; align-items: center">

                                </div>
                            </div>


                            <div style="width: 25%; height: 100%; float: left">
                                <div style="width: 100%; height: 60%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 15vh">
                                    {{activeMinutes}}
                                </div>
                                <div style="width: 100%; height: 40%; display: flex; justify-content: center; align-items: center">
                                    Minutes
                                </div>
                            </div>

                            <div style="width: 2%; height: 100%; float: left">
                                <div style="width: 100%; height: 60%; display: flex; justify-content: center; align-items: center; font-size: 10vh">
                                    :
                                </div>
                                <div style="width: 100%; height: 40%; display: flex; justify-content: center; align-items: center">

                                </div>
                            </div>


                            <div style="width: 25%; height: 100%; float: left">
                                <div style="width: 100%; height: 60%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 15vh">
                                    {{activeSeconds}}
                                </div>
                                <div style="width: 100%; height: 40%; display: flex; justify-content: center; align-items: center">
                                    Seconds
                                </div>
                            </div>


                        </div>

                        <div style="width: 100%; height: 20%; display: flex; justify-content: center; align-items: center">
                            <v-btn style="width: 30%; height: 70%"
                                   color="#2e2e2e"
                                   dark
                                   rounded
                                   @click="activateBundle(false)"
                            >
                                Deactivate
                            </v-btn>
                        </div>







                    </div>

                </v-card>

            </v-overlay>
            <v-stepper  style="width: 100%; height: 100%;" v-model="e1">
                <v-stepper-header style="height: 10%; width: 100%">
                    <v-stepper-step complete-icon="fas fa-check" color="#2e2e2e" :complete="e1 > 1" step="1"></v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step complete-icon="fas fa-check" color="#2e2e2e" :complete="e1 > 2" step="2"></v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step complete-icon="fas fa-check" color="#2e2e2e" step="3"></v-stepper-step>
                </v-stepper-header>

                <v-stepper-items style="height: 90%; width: 100%">
                    <v-stepper-content style="width: 100%; height: 100%; padding: 0" step="1">
                        <v-card style="width: 100%; height: 100%">

                            <div style="width: 100%; height: 90%;">

                                <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-weight: bold;font-size: 3.5vh; color: rgba(0,0,0,0.6)">
                                    Promotion Information
                                </div>

                                <div style="width: 100%; height: 70%;">

                                    <div class="split-area-content">

                                        <div class="content-edit">
                                            <v-text-field
                                                    label="Promotion Name"
                                                    v-model="promotionalName"
                                                    :rules="rules.name"
                                                    prepend-icon="fas fa-signature"
                                                    clearable
                                                    color="black"
                                            ></v-text-field>
                                        </div>

                                        <div class="content-edit">

                                            <v-text-field
                                                    label="Bundle Title"
                                                    v-model="bundleName"
                                                    :rules="rules.name"
                                                    prepend-icon="fas fa-text-width"
                                                    clearable
                                                    color="black"
                                            ></v-text-field>

                                        </div>

                                        <div class="content-edit">
                                            <v-text-field class="price-edit"
                                                          style="padding-right: 1%;"
                                                          label="Price UK"
                                                          prepend-icon="fas fa-pound-sign"
                                                          :rules="rules.name"
                                                          clearable
                                                          color="black"
                                                          v-model="ukPayment"
                                            ></v-text-field>

                                            <v-text-field class="price-edit"
                                                          style="padding-left: 1%;"
                                                          label="Credit UK"
                                                          prepend-icon="fas fa-pound-sign"
                                                          color="black"
                                                          :rules="rules.name"
                                                          clearable
                                                          v-model="ukCredit"
                                            ></v-text-field>

                                        </div>

                                        <div class="content-edit">

                                            <v-text-field class="price-edit"
                                                          style="padding-right: 1%;"
                                                          label="Price AUS"
                                                          clearable
                                                          color="black"
                                                          :rules="rules.name"
                                                          prepend-icon="fas fa-dollar-sign"
                                                          v-model="ausPayment"
                                            ></v-text-field>

                                            <v-text-field class="price-edit"
                                                          style="padding-left: 1%"

                                                          label="Credit AUS"
                                                          clearable
                                                          :rules="rules.name"
                                                          prepend-icon="fas fa-coins"
                                                          color="black"
                                                          v-model="ausCredit"
                                            ></v-text-field>

                                        </div>

                                    </div>


                                </div>

                                <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-weight: bold;font-size: 3.5vh; color: rgba(0,0,0,0.6)">
                                    <v-btn style="width: 40%; height: 70%; color: white"
                                           color="#2e2e2e"
                                           rounded
                                           :disabled="computedDisableButton"
                                           @click="e1 = 2"
                                    >
                                        Continue
                                    </v-btn>
                                </div>





                            </div>



                        </v-card>
                    </v-stepper-content>
                    <v-stepper-content style="width: 100%; height: 100%; padding: 0" step="2">
                        <v-card style="width: 100%; height: 100%">
                            <div style="width: 100%; height: 90%;">
                                <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-weight: bold;font-size: 3.5vh; color: rgba(0,0,0,0.6)">
                                    Promotion Presentation
                                </div>
                                <div style="width: 100%; height: 70%;">
                                    <div style="width: 100%; height: 20%">
                                        <div @mouseleave="showResetBadge = false" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">

                                            <v-badge
                                                    color="blue"
                                                    right
                                                    overlap
                                            >

                                                <template v-if="showResetBadge" v-slot:badge>
                                                    <span ><v-icon    @click="resetBadge" style="font-size: 10px" color="white">fas fa-undo-alt</v-icon></span>
                                                </template>

                                                <div @mouseenter="showResetBadge = true" style="width: 225px; height: 55px" class="bundle-number" v-bind:style="{color: bundleTextColor, background: bundleBackgroundColor, backgroundSize: coverBackground}">{{bundleName}}</div>


                                            </v-badge>








                                        </div>
                                    </div>
                                    <div style="width: 100%; height: 80%">

                                        <div style="width: 50%; height: 100%; float: left">

                                            <div style="width: 100%; height: 20%; display: flex; justify-content: center; align-items: center; font-weight: bold;font-size: 1.5vh; color: rgba(0,0,0,0.6)">
                                                <div style="padding-left: 20% ;float: left;width: 80%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                    Badge Background
                                                </div>
                                                <div style="float: left;width: 20%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                    <v-btn @click="openCustomBadgeCreator" x-small icon>
                                                        <v-icon style="font-size: 2.5vh">
                                                            {{badgeBackgroundOpenIcon}}
                                                        </v-icon>
                                                    </v-btn>
                                                </div>
                                            </div>

                                            <div style="width: 100%; height: 80%; display: flex; justify-content: center; align-items: center">

                                                <v-fade-transition>
                                                    <v-card flat v-if="showBackgroundEditOption1 == true" style="width: 100%; height: 100%">
                                                        <v-list  rounded dense style="height: 100%; width: 50%; margin-right: auto; margin-left: auto"
                                                        >
                                                            <v-list-item-group
                                                                    v-model="chosenPreSetBackground">
                                                                <v-list-item
                                                                        style="height: 47.5px"
                                                                        color="#2e2e2e"
                                                                        :disabled="bundleActiveToggle"
                                                                        v-for="(back, i) in presetBackgroundColor"
                                                                        :key="i"
                                                                >
                                                                    <v-list-item-avatar size="25">
                                                                        <v-img style="box-shadow: 1px 1px 5px grey;background: radial-gradient(ellipse farthest-corner at right top, #FFFFFF 0%, #ffb3ff 8%, #ff33ff 25%, #800080 62.5%, #b300b3 100%)" :src="back.preview"></v-img>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title v-text="back.text"></v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-fade-transition>

                                                <v-fade-transition>
                                                    <v-card flat v-if="showBackgroundEditOption2 == true" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center">

                                                        <v-card flat style="width: 100%; height: 50%">
                                                            <v-text-field
                                                                    style="width: 70%; margin-left: auto; margin-right: auto"
                                                                    label="Background URL"
                                                                    clearable
                                                                    prepend-icon="fas fa-link"
                                                                    v-model="bundleBackgroundColorText"
                                                                    :disabled="bundleActiveToggle"
                                                                    hint="Please enter full URL of destination image"
                                                            ></v-text-field>
                                                        </v-card>

                                                    </v-card>
                                                </v-fade-transition>
                                            </div>
                                        </div>

                                        <div style="width: 50%; height: 100%; float: left">
                                            <div style="width: 100%; height: 20%; font-weight: bold;font-size: 1.5vh; color: rgba(0,0,0,0.6)">
                                                <div style="padding-left: 20% ;float: left;width: 80%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                    Badge Text Colour
                                                </div>
                                                <div style="float: left;width: 20%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                    <v-btn @click="openCustomTextCreator" x-small icon>
                                                        <v-icon style="font-size: 2.5vh">
                                                            {{badgeTextOpenIcon}}
                                                        </v-icon>
                                                    </v-btn>
                                                </div>
                                            </div>

                                            <div style="width: 100%; height: 80%; display: flex; justify-content: center; align-items: center">

                                                <v-fade-transition>
                                                    <v-card flat v-if="showTextEditOption1 == true" style="width: 100%; height: 100%">
                                                        <v-list rounded dense style="height: 100%; width: 50%; margin-right: auto; margin-left: auto"
                                                        >
                                                            <v-list-item-group
                                                                    v-model="chosenPreSetText">
                                                                <v-list-item
                                                                        style="height: 47.5px"
                                                                        color="#2e2e2e"
                                                                        :disabled="bundleActiveToggle"
                                                                        v-for="(item, i) in presetTextColor"
                                                                        :key="i"
                                                                >
                                                                    <v-list-item-avatar size="25">
                                                                        <v-img style=" box-shadow: 1px 1px 5px grey;" v-bind:style="{background: item.text}"></v-img>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title v-text="item.text"></v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-fade-transition>
                                                <v-fade-transition>
                                                    <v-card flat v-if="showTextEditOption2 == true" style=";width: 100%; height: 100%; display: flex; justify-content: center; align-items: center">
                                                        <v-color-picker style="width: 100%; height: 100%;"
                                                                        v-model="bundleTextColor"
                                                                        canvas-height="100px"
                                                                        flat
                                                                        dot-size="20px"
                                                                        hide-inputs
                                                        ></v-color-picker>

                                                    </v-card>
                                                </v-fade-transition>

                                            </div>



                                        </div>




                                    </div>





                                </div>

                                <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-weight: bold;font-size: 3.5vh; color: rgba(0,0,0,0.6)">

                                    <div style="float: left ;width: 30%; height: 100%; display: flex; justify-content: center; align-items: center">
                                        <v-btn style="width: 40%; height: 70%"
                                               color="#2e2e2e"
                                               dark
                                               icon

                                               rounded
                                               @click="e1 = 1"
                                        >
                                            <v-icon>fas fa-caret-left</v-icon>
                                        </v-btn>
                                    </div>

                                    <div style="padding-right: 30% ;float: left ;width: 70%; height: 100%; display: flex; justify-content: center; align-items: center">
                                        <v-btn style="width: 100%; height: 70%"
                                               color="#2e2e2e"
                                               dark
                                               rounded
                                               @click="e1 = 3"
                                        >
                                            Continue
                                        </v-btn>
                                    </div>
                                </div>





                            </div>



                        </v-card>
                    </v-stepper-content>

                    <v-stepper-content style="width: 100%; height: 100%; padding: 0" step="3">
                        <v-card style="width: 100%; height: 100%">

                            <div style="width: 100%; height: 90%;">

                                <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-weight: bold;font-size: 3.5vh; color: rgba(0,0,0,0.6)">
                                    Promotion Finalisation
                                </div>

                                <div style="width: 100%; height: 70%;">


                                    <div style="width: 100%; height: 10%; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.6); font-size: 2vh">

                                        You are about to publish a promotional bundle with the information below

                                    </div>

                                    <div style="width: 50%; height: 90%; float: left">

                                        <div style="font-weight: bold ;width: 100%; height: 10%; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.6); font-size: 2vh">

                                            <div style="padding-left: 20%;float: left;width: 80%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                Bundle Badge
                                            </div>

                                            <div style="float: left;width: 20%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                <v-btn @click="e1 = 2" x-small icon><v-icon style="font-size: 2.5vh">fas fa-edit</v-icon></v-btn>
                                            </div>

                                        </div>

                                        <div style="width: 100%; height: 90%">

                                            <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
                                                <div class="bundle-number-2" v-bind:style="{color: bundleTextColor, background: bundleBackgroundColor, backgroundSize: coverBackground}">{{bundleName}}</div>
                                            </div>


                                        </div>

                                    </div>

                                    <div style="width: 50%; height: 90%; float: left">

                                        <div style="font-weight: bold ;width: 100%; height: 10%; color: rgba(0,0,0,0.6); font-size: 2vh">

                                            <div style="padding-left: 20%;float: left;width: 80%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                Bundle Information
                                            </div>

                                            <div style="float: left;width: 20%; height: 100%; display: flex; justify-content: center; align-items: center;">
                                                <v-btn @click="e1 = 1" x-small icon><v-icon style="font-size: 2.5vh">fas fa-edit</v-icon></v-btn>
                                            </div>

                                        </div>

                                        <div style="width: 100%; height: 90%">

                                            <div class="split-area-content">

                                                <div class="content-edit">
                                                    <v-text-field
                                                            label="Promotion Name"
                                                            v-model="promotionalName"
                                                            readonly
                                                            disabled
                                                            prepend-icon="fas fa-signature"
                                                            color="rgba(0,0,0,0.4)"
                                                    ></v-text-field>
                                                </div>

                                                <div class="content-edit">

                                                    <v-text-field
                                                            label="Bundle Title"
                                                            v-model="bundleName"
                                                            prepend-icon="fas fa-text-width"
                                                            readonly
                                                            disabled

                                                            color="rgba(0,0,0,0.4)"
                                                    ></v-text-field>

                                                </div>

                                                <div class="content-edit">
                                                    <v-text-field class="price-edit"
                                                                  style="padding-right: 1%;"
                                                                  label="Price UK"
                                                                  prepend-icon="fas fa-pound-sign"
                                                                  readonly
                                                                  disabled
                                                                  color="rgba(0,0,0,0.4)"
                                                                  v-model="ukPayment"
                                                    ></v-text-field>

                                                    <v-text-field class="price-edit"
                                                                  style="padding-left: 1%;"
                                                                  label="Credit UK"
                                                                  prepend-icon="fas fa-pound-sign"
                                                                  readonly
                                                                  disabled
                                                                  v-model="ukCredit"
                                                                  color="rgba(0,0,0,0.4)"
                                                    ></v-text-field>

                                                </div>

                                                <div class="content-edit">

                                                    <v-text-field class="price-edit"
                                                                  style="padding-right: 1%;"
                                                                  label="Price AUS"
                                                                  disabled
                                                                  color="rgba(0,0,0,0.4)"
                                                                  readonly
                                                                  prepend-icon="fas fa-dollar-sign"
                                                                  v-model="ausPayment"
                                                    ></v-text-field>

                                                    <v-text-field class="price-edit"
                                                                  style="padding-left: 1%"
                                                                  readonly
                                                                  disabled
                                                                  label="Credit AUS"
                                                                  prepend-icon="fas fa-coins"
                                                                  color="rgba(0,0,0,0.4)"
                                                                  v-model="ausCredit"
                                                    ></v-text-field>

                                                </div>

                                            </div>


                                        </div>



                                    </div>



                                </div>

                                <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-weight: bold;font-size: 3.5vh; color: rgba(0,0,0,0.6)">

                                    <div style="float: left ;width: 30%; height: 100%; display: flex; justify-content: center; align-items: center">
                                        <v-btn style="width: 40%; height: 70%"
                                               color="#2e2e2e"
                                               dark
                                               icon

                                               rounded
                                               @click="e1 = 2"
                                        >
                                            <v-icon>fas fa-caret-left</v-icon>
                                        </v-btn>
                                    </div>

                                    <div style="padding-right: 30% ;float: left ;width: 70%; height: 100%; display: flex; justify-content: center; align-items: center">
                                        <v-btn style="width: 100%; height: 70%"
                                               color="#2e2e2e"
                                               dark
                                               rounded
                                               @click="activateBundle(true)"
                                        >
                                            Activate
                                        </v-btn>
                                    </div>
                                </div>







                            </div>



                        </v-card>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>


        </v-card>

    </v-app>
</template>

<script>
    import Vue from 'vue'
    import Vuetify from 'vuetify'
    import 'vuetify/dist/vuetify.min.css'
    import { AXIOS } from '../../http-common'
    Vue.use(Vuetify)
    export default {
        data () {
            return {
                showDays:false,
                activeSeconds:'00',
                activeMinutes:"00",
                activeHours:"00",
                activeDays:'0',
                bundleActiveSince:'',

                disableInfoButton: true,

                showResetBadge: false,

                showBackgroundEditOption1: true,
                showBackgroundEditOption2: false,

                showTextEditOption1: true,
                showTextEditOption2: false,

                toggleBadgeBackgroundEdit: false,
                badgeBackgroundOpenIcon:'far fa-dot-circle',

                toggleBadgeTextEdit: false,
                badgeTextOpenIcon: 'far fa-dot-circle',

                activateButtonColor:'#2e2e2e',

                e1: 1,

                showHeader: true,

                bundleBackgroundColorText: '',

                chosenPreSetText: '',
                chosenPreSetBackground: '',
                coverBackground: '',

                presetTextColor: [
                    { text: 'Black' },
                    { text: 'White' },
                    { text: 'Gray' }
                ],

                presetBackgroundColor: [
                    { text: 'Default', preview: '' },
                    { text: 'Snow', preview: 'https://motionarray.imgix.net/preview-125086-x4Jybc73C3-low_0012.jpg?w=660&q=60&fit=max&auto=format' },
                    { text: 'Lava', preview: 'https://st2.depositphotos.com/2339653/8916/i/950/depositphotos_89160370-stock-photo-orange-background-for-halloween-grunge.jpg' },
                    { text: 'Eggs', preview: 'https://t3.ftcdn.net/jpg/01/44/12/26/240_F_144122622_lL63KqXOekv7AwTdZphqG7M9Qf8KZeSA.jpg' },
                ],

                buttonColorEditor: false,
                backgroundEditor: false,

                bundleBackgroundColor: '',
                bundleTextColor: '',
                // Snackbar User notification Start
                snackbar: false,
                y: 'top',
                timeout: 5000,
                // Snackbar User notification End
                rules: { // Checks field length if 0 say 'Required field'
                    name: [val => (val || '').length > 0 || 'Required field']
                },
                bundleName: '',
                activeIcon: '', // Dynamic variable to display active state icon
                activeText: '', // Dynamic variable to display active state text
                activeColor: '', // Dynamic variable to display active color state for the icon
                promoBundle: {}, // Get request data array
                promotionalName: '', // Variable to process promotional name data
                ukPayment: '', // Variable to process uk payment data
                ausPayment: '', // Variable to process aus payment data
                ukCredit: '', // Variable to process uk credit data
                ausCredit: '', // Variable to process aus credit data
                promoNamePresent: false, // Defines if promotional name is present, by default false, used for activate button
                ukCreditPresent: false, // Defines if uk credit is present, by default false, used for activate button
                ukPaymentPresent: false, // Defines if uk payment is present, by default false, used for activate button
                ausPaymentPresent: false, // Defines if aus payment is present, by default false, used for activate button
                ausCreditPresent: false, // Defines if aus credit is present, by default false, used for activate button
                bundleActiveButtonText: 'Activate Bundle', // Defines the default text for promo activate button
                bundleActiveToggle: false, // Defines if the button should be disabled
                activeBackground: '', // Defines the background of the area if the button is disabled (grays out the area if active to show that cant update)
                activeOpacity: '',/// /Defines the opacity of the area if the button is disabled (grays out the area if active to show that cant update)
                testTime: "2020-05-18T16:38:00"
            }
        },
        watch: {

            bundleBackgroundColorText: function () {
                if (this.bundleBackgroundColorText != null || this.bundleBackgroundColorText != '') {
                    this.bundleBackgroundColor = 'url("' + this.bundleBackgroundColorText + '")'
                    this.coverBackground = 'cover'
                } else if (this.bundleBackgroundColorText == null) {
                    this.bundleBackgroundColor = 'radial-gradient(ellipse farthest-corner at right top, #FFFFFF 0%, #ffb3ff 8%, #ff33ff 25%, #800080 62.5%, #b300b3 100%)'
                    this.coverBackground = ''
                }
            },

            chosenPreSetText: function () {
                if (this.chosenPreSetText == 0) {
                    this.bundleTextColor = 'black'
                } else if (this.chosenPreSetText == 1) {
                    this.bundleTextColor = 'white'
                } else if (this.chosenPreSetText == 2) {
                    this.bundleTextColor = 'gray'
                }
            },

            chosenPreSetBackground: function () {
                if (this.chosenPreSetBackground == 0) {
                    this.bundleBackgroundColor = 'radial-gradient(ellipse farthest-corner at right top, #FFFFFF 0%, #ffb3ff 8%, #ff33ff 25%, #800080 62.5%, #b300b3 100%)'
                    this.coverBackground = ''
                } else if (this.chosenPreSetBackground == 1) {
                    this.coverBackground = 'cover'
                    this.bundleBackgroundColor = 'url("https://motionarray.imgix.net/preview-125086-x4Jybc73C3-low_0012.jpg?w=660&q=60&fit=max&auto=format")'
                } else if (this.chosenPreSetBackground == 2) {
                    this.bundleBackgroundColor = 'url("https://st2.depositphotos.com/2339653/8916/i/950/depositphotos_89160370-stock-photo-orange-background-for-halloween-grunge.jpg")'
                    this.coverBackground = 'cover'
                } else if (this.chosenPreSetBackground == 3) {
                    this.bundleBackgroundColor = 'url("https://t3.ftcdn.net/jpg/01/44/12/26/240_F_144122622_lL63KqXOekv7AwTdZphqG7M9Qf8KZeSA.jpg")'
                    this.coverBackground = ''
                }
            },

            // Defines if promotionalName field is empty, changes variable boolean for computedDisableButton
            promotionalName: function () {
                if (this.promotionalName == null || this.promotionalName == '') {
                    this.promoNamePresent = false
                } else {
                    this.promoNamePresent = true
                }
            },
            // Defines if ukCredit field is empty, changes variable boolean for computedDisableButton
            ukCredit: function () {
                if (this.ukCredit == null || this.ukCredit == '') {
                    this.ukCreditPresent = false
                } else {
                    this.ukCreditPresent = true
                }
            },
            // Defines if ukPayment field is empty, changes variable boolean for computedDisableButton
            ukPayment: function () {
                if (this.ukPayment == null || this.ukPayment == '') {
                    this.ukPaymentPresent = false
                } else {
                    this.ukPaymentPresent = true
                }
            },
            // Defines if ausPayment field is empty, changes variable boolean for computedDisableButton
            ausPayment: function () {
                if (this.ausPayment == null || this.ausPayment == '') {
                    this.ausPaymentPresent = false
                } else {
                    this.ausPaymentPresent = true
                }
            },
            // Defines if ausCredit field is empty, changes variable boolean for computedDisableButton
            ausCredit: function () {
                if (this.ausCredit == null || this.ausCredit == '') {
                    this.ausCreditPresent = false
                } else {
                    this.ausCreditPresent = true
                }
            }
        },
        created: function () {
            // On load gets bundle information
            document.title = 'Chattube - Promotions'
            this.getBundleInfo()
        },
        computed: {

            // Defines if all fields are filled, if not the user will not be able to save the bundle
            computedDisableButton () {
                if (this.promoNamePresent == true && this.ukCreditPresent == true && this.ukPaymentPresent == true && this.ausCreditPresent == true && this.ausPaymentPresent == true) {
                    this.enableButton = false
                } else {
                    this.enableButton = true
                }
                return this.enableButton
            }
        },
        methods: {

            computedActiveSinceSeconds() {
                var timeDifference =  new Date() - new Date(this.bundleActiveSince)
                var differenceInMinutes = (timeDifference / 1000).toFixed(0)
                var minutesFromTheseSeconds = Math.floor(timeDifference / 60 / 1000)
                var secondsInCurrentMinutes = differenceInMinutes - (60 * minutesFromTheseSeconds)
                if (secondsInCurrentMinutes < 10){
                    secondsInCurrentMinutes = "0"+secondsInCurrentMinutes
                }
                if (secondsInCurrentMinutes == 60){
                    var secondsInCurrentMinutes = "00"
                }
                this.activeSeconds = secondsInCurrentMinutes
            },

            computedActiveSinceMinutes() {
                var timeDifference =  new Date() - new Date(this.bundleActiveSince)
                // var timeDifference =  new Date() - new Date(this.testTime)
                var differenceInMinutes = (timeDifference / 1000).toFixed(0)
                var minutesFromTheseSeconds = Math.floor(differenceInMinutes / 60)
                if (minutesFromTheseSeconds >= 60){
                    var timesHours = minutesFromTheseSeconds / 60
                    var splitHours = timesHours.toString().split(".")[0]
                    var minutesFromTheseSeconds = minutesFromTheseSeconds - (60 * splitHours)
                }
                if (minutesFromTheseSeconds < 10){
                    minutesFromTheseSeconds = "0"+minutesFromTheseSeconds
                }
                this.activeMinutes = minutesFromTheseSeconds
            },

            computedActiveSinceHours() {
                var timeDifference =  new Date() - new Date(this.bundleActiveSince)
                // var timeDifference =  new Date() - new Date(this.testTime)
                var differenceInMinutes = (timeDifference / 1000).toFixed(0)
                var minutesFromTheseSeconds = Math.floor(differenceInMinutes / 60)
                if (minutesFromTheseSeconds >= 60){
                    var timesHours = minutesFromTheseSeconds / 60
                    var splitHours = timesHours.toString().split(".")[0]
                    var timesHours = splitHours
                }
                else {
                    var timesHours = 0
                }
                if  (timesHours >= 24){
                    this.showDays = true
                    var daysDiff = timesHours / 24
                    var daysDiff = daysDiff.toString().split(".")[0]
                    var timesHours = timesHours - (24 * daysDiff)
                }
                else {
                    this.showDays = false
                }
                if (timesHours < 10){
                    timesHours = "0"+timesHours
                }
                this.activeHours = timesHours
            },

            computedActiveSinceDays() {
                var timeDifference =  new Date() - new Date(this.bundleActiveSince)
                // var timeDifference =  new Date() - new Date(this.testTime)
                var differenceInMinutes = (timeDifference / 1000).toFixed(0)
                var minutesFromTheseSeconds = Math.floor(differenceInMinutes / 60)
                if (minutesFromTheseSeconds >= 60){
                    var timesHours = minutesFromTheseSeconds / 60
                    var splitHours = timesHours.toString().split(".")[0]
                    var timesHours = splitHours
                    if  (timesHours >= 24){
                        var daysDiff = timesHours / 24
                        var daysDiff = daysDiff.toString().split(".")[0]
                    }
                    else {
                        var daysDiff = 0
                    }
                }
                this.activeDays = daysDiff
            },

            openCustomBadgeCreator() {
                this.toggleBadgeBackgroundEdit = !this.toggleBadgeBackgroundEdit
                if (this.toggleBadgeBackgroundEdit == false){
                    this.badgeBackgroundOpenIcon = 'far fa-dot-circle'
                    this.showBackgroundEditOption2 = false
                    setTimeout(() => this.showBackgroundEditOption1 = true, 500)
                }
                else if (this.toggleBadgeBackgroundEdit == true){
                    this.badgeBackgroundOpenIcon = 'fas fa-dot-circle'
                    this.showBackgroundEditOption1 = false
                    setTimeout(() => this.showBackgroundEditOption2 = true, 500)
                }
            },

            openCustomTextCreator() {
                this.toggleBadgeTextEdit = !this.toggleBadgeTextEdit
                if (this.toggleBadgeTextEdit == false){
                    this.badgeTextOpenIcon = 'far fa-dot-circle'

                    this.showTextEditOption2 = false
                    setTimeout(() => this.showTextEditOption1 = true, 500)
                }
                else if (this.toggleBadgeTextEdit == true){
                    this.badgeTextOpenIcon = 'fas fa-dot-circle'

                    this.showTextEditOption1 = false
                    setTimeout(() => this.showTextEditOption2 = true, 500)
                }
            },

            confirmActivation() {
                this.activateButtonColor = 'red'
            },

            resetBadge () {
                this.bundleName = this.promoBundle.bundleName
                this.bundleBackgroundColor = this.promoBundle.badgeBackground
                this.bundleTextColor = this.promoBundle.badgeTextColor
            },

            toggleBackgroundEdit () {
                this.backgroundEditor = !this.backgroundEditor
            },

            toggleButtonColorEdit () {
                this.buttonColorEditor = !this.buttonColorEditor
            },

            // Bundle activation process
            activateBundle (activeStatus) {
                // Checks the current state, applies styling.

                this.showHeader = false
                setTimeout(() => this.showHeader = true, 250)

                if (this.promoBundle.active == false) {
                    this.bundleActiveToggle = true

                    var currentDate = new Date().toJSON().substr(0,10)
                    var currentTime = new Date().toTimeString().substr(0,8)

                    this.activeSinceStatus = currentDate + "T" + currentTime + ".000"
                } else if (this.promoBundle.active == true) {
                    this.bundleActiveToggle = false
                    this.activeSinceStatus = ""
                }


                // Executes call to the database
                AXIOS({
                    method: 'POST',
                    url: 'api/admin/promo/save',
                    headers: {
                        Authorization: 'Bearer ' + window.$cookies.get('session')
                    },
                    data: {
                        id: this.promoBundle.id,
                        promoName: this.promotionalName,
                        bundleName: this.bundleName,
                        amountUk: this.ukPayment,
                        amountAs: this.ausPayment,
                        badgeBackground: this.bundleBackgroundColor,
                        badgeTextColor: this.bundleTextColor,
                        creditUk: this.ukCredit,
                        creditAs: this.ausCredit,
                        active: this.bundleActiveToggle,
                        activeSince: this.activeSinceStatus,
                    }
                })
                    .then(response => {
                            this.getBundleInfo() // On success get bundle information
                        },
                        (err) => {
                            // If user not authorised disable section and inform user
                            if (err.response.status == 403 || err.response.status == 401) {
                                this.activeBackground = 'rgba(0,0,0,0.3)'
                                this.activeOpacity = 0.2
                                this.bundleActiveToggle = true
                                this.bundleActiveButtonText = 'Activate Bundle'
                                this.snackbar = true
                            }
                        }
                    )
            },
            // Checks if bundle is active if is apply styling/disable buttons and fields
            checkIfActive () {
                if (this.promoBundle.active == true) {
                    setInterval(this.computedActiveSinceMinutes, 1000);
                    setInterval(this.computedActiveSinceSeconds, 1000);
                    setInterval(this.computedActiveSinceHours, 1000);
                    setInterval(this.computedActiveSinceDays, 1000);
                    this.activeIcon = 'fas fa-check-circle'
                    this.activeColor = '#4BB543'
                    this.activeText = 'Active'
                    this.activeBackground = 'rgba(0,0,0,0.3)'
                    this.activeOpacity = 0.2
                    this.bundleActiveToggle = true
                    this.bundleActiveButtonText = 'Disable Bundle'
                } else if (this.promoBundle.active == false) {
                    this.activeIcon = 'fas fa-times-circle'
                    this.activeColor = '#CD0000'
                    this.activeText = 'Inactive'
                    this.activeBackground = ''
                    this.activeOpacity = 1
                    this.bundleActiveToggle = false
                    this.bundleActiveButtonText = 'Activate Bundle'
                }
            },
            // Get bundle information
            getBundleInfo () {
                AXIOS({
                    method: 'GET',
                    url: '/api/promo',
                    headers: {
                        Authorization: 'Bearer ' + window.$cookies.get('session')
                    }
                }).then(response => {

                    this.promoBundle = response.data[0]
                    this.promotionalName = this.promoBundle.promoName
                    this.bundleName = this.promoBundle.bundleName
                    this.bundleBackgroundColor = this.promoBundle.badgeBackground
                    this.bundleTextColor = this.promoBundle.badgeTextColor
                    this.ukPayment = this.promoBundle.amountUk.toString()
                    this.ausPayment = this.promoBundle.amountAs.toString()
                    this.ukCredit = this.promoBundle.creditUk.toString()
                    this.ausCredit = this.promoBundle.creditAs.toString()
                    this.bundleActiveSince = this.promoBundle.activeSince

                    this.checkIfActive()

                })
            }
        }
    }
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
    }

    #promo-head {
        height: 10%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 2vw;
        color: rgba(0,0,0,0.35);

    }

    #promo-area {
        height: 100%;
        width: 100%;

    }

    #promo-save-changes {
        height: 10%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .area-split {
        height: 100%;
        width: 50%;
        float: left;
    }

    .split-area-header {

        height: 10%;
        width: 100%;

        font-weight: bold;
        font-size: 1.5vw;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    .split-area-content {

        height: 90%;
        width: 100%;

    }

    .content-edit {
        width: 100%;
        height: 25%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-right: 3%;
        padding-left: 3%;
    }

    .price-edit {
        width: 50%;
        float: left;
    }

    #card-banner {

        height: 10%;
        width: 100%;

        background: red;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    .bundle-number {
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2vw;
        background-size: cover;

        height: 80%;
        width: 30%;
        border-radius:12.5px;
        margin: 0;
    }

    .bundle-number-2 {
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2vw;
        background-size: cover;

        height: 30%;
        width: 50%;
        border-radius:12.5px;
        margin: 0;
    }

    .badge-demo {
        width: 100%;
        height: 30%;
    }

    #badge-editor {
        width: 100%;
        height: 70%;
    }
    .badge-editor-section {
        width: 50%;
        height: 100%;
        float: left;
    }
    .edit-section-header {
        height: 15%;
        width: 100%;
        color:rgba(0,0,0,0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1vw;
    }

    .edit-section-tool {
        height: 85%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>
